import { useApp } from "@/context/AppContext";
import { T } from "@/i18n/translations";

export const Marquee = () => {
  const { lang } = useApp();
  const items = T.marquee[lang] || T.marquee.en;
  const row = [...items, ...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-petrol/15 bg-petrol py-4">
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {row.map((it, i) => (
          <div key={i} className="flex items-center gap-10">
            <span className="font-serif text-lg italic text-sand/90">{it}</span>
            <span className="text-terracotta">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};
